import config from '@/config';

export const ipaUrl = 'https://ipa.lumiqlearn.com';
const bffURL = `${ipaUrl}/bff`;
const actionsURL = 'https://actions.lumiqlearn.com';
const branchURL = 'https://lumiq.app.link';

const getBaseUrl = () => window.location.origin;

export const urls = {
  base: getBaseUrl(),
  appBase: config.APP_ROOT || 'https://app.lumiqlearn.com',
  lumiq: {
    CAN: 'https://lumiqlearn.com',
    USA: 'https://lumiqlearn.com/us/home',
    GBR: 'https://lumiqlearn.com/uk/home',
  },
  about: {
    CAN: 'https://lumiqlearn.com/ca/about-us',
    USA: 'https://lumiqlearn.com/us/about-us',
    GBR: 'https://lumiqlearn.com/uk/about-us',
  },
  lumiqPrivacy: {
    CAN: 'https://lumiqlearn.com/ca/privacy-policy',
    USA: 'https://lumiqlearn.com/us/privacy-policy',
    GBR: 'https://lumiqlearn.com/uk/privacy-policy',
  },
  pricingDetails: {
    CAN: 'https://lumiqlearn.com/ca/pricing#compare-plans',
    USA: 'https://lumiqlearn.com/us/pricing#compare-plans',
    GBR: 'https://lumiqlearn.com/uk/pricing#compare-plans',
  },
  bookADemo: {
    CAN: 'https://lumiqlearn.com/ca/demo',
    USA: 'https://lumiqlearn.com/us/demo',
    GBR: 'https://lumiqlearn.com/uk/demo',
  },
  faq: 'https://intercom.help/lumiq/en/',
  lumiqTC: 'https://lumiqlearn.com/terms',
  social: {
    facebook: 'https://facebook.com/lumiqlearn',
    instagram: 'https://instagram.com/lumiqlearn',
    linkedin: 'https://linkedin.com/company/lumiqlearn',
    x: 'https://twitter.com/lumiqlearn',
  },
  auth: {
    google: `${bffURL}/auth/google`,
    apple: `${bffURL}/auth/apple`,
    workos: `${bffURL}/auth/workos/callback`,
    mobileRedirect: `${branchURL}/auth`,
  },
  actions: {
    root: actionsURL,
    logrocket: `${actionsURL}/logrocket/api/i`,
    sentry: `${actionsURL}/sentry`,
    mixpanel: `${actionsURL}/mixpanel/api`,
    growthbook: 'https://cdn.growthbook.io',
    datadog: 'datadoghq.com',
  },
  supportEmail: 'help@lumiqlearn.com',
  downloadApp: 'https://lumiq.app.link/tWrOXwdEinb',
  appLogin: 'https://lumiq.app.link/auth',
  intercom: {
    addRecoveryEmailArticle:
      'https://intercom.help/lumiq/en/articles/11070475-how-to-add-a-recovery-email-on-lumiq',
  },
  trustPilot: {
    CAN: 'https://ca.trustpilot.com/review/lumiqlearn.com',
    USA: 'https://www.trustpilot.com/review/lumiqlearn.com',
    GBR: 'https://www.trustpilot.com/review/lumiqlearn.com',
  },
} as const;

export const EpisodeShareSocialLinks = [
  {
    platform: 'LinkedIn',
    params: [
      'utm_source=linkedin',
      'utm_medium=organic',
      'utm_campaign=organic_episode_share',
    ],
  },
  {
    platform: 'Instagram',
    params: [
      'utm_source=instagram',
      'utm_medium=organic',
      'utm_campaign=organic_episode_share',
    ],
  },
  {
    platform: 'Facebook',
    params: [
      'utm_source=facebook',
      'utm_medium=organic',
      'utm_campaign=organic_episode_share',
    ],
  },
] as const;
